import React from "react";
import { Stack } from "@mui/material";
import { ClearCallLogo } from "./clear-call-logo";

export const ClearCallLoadingLogo: React.FC = () => {

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Loading animation container with pulsing logo and spinning border */}
      <div
        style={{
          position: "relative",
          animation: "pulse 2s ease-in-out infinite",
        }}
      >
        {/* Company logo */}
        <ClearCallLogo size={100} />
        {/* Spinning border around the logo */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "180px",
            height: "180px",
            border: "3px solid rgba(0, 123, 255, 0.3)",
            borderTop: "3px solid rgb(5, 153, 179)",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
      </div>
      {/* CSS animations for the loading spinner */}
      <style>
        {`
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
                transform: scale(1);
              }
              50% {
                opacity: 0.7;
                transform: scale(1.05);
              }
            }
            @keyframes spin {
              0% { transform: translate(-50%, -50%) rotate(0deg); }
              100% { transform: translate(-50%, -50%) rotate(360deg); }
            }
          `}
      </style>
    </Stack>)
};

export default ClearCallLoadingLogo;
